import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useRefreshUser } from '@/hooks/useRefreshUser';
import { POST_PAYMENT_PARAM, ROUTE_HOME } from '@/router/routes';

const USER_REFRESH_DELAY_MS = 5000;

export const usePostPaymentRefresh = () => {
  const navigate = useNavigate();
  const refreshUser = useRefreshUser();
  const [searchParams] = useSearchParams();
  const [isPostPayment] = useState(
    searchParams.get(POST_PAYMENT_PARAM) === 'true',
  );

  useEffect(() => {
    if (!isPostPayment) {
      return;
    }

    navigate(ROUTE_HOME, { replace: true });

    const timeoutId = setTimeout(refreshUser, USER_REFRESH_DELAY_MS);

    return () => clearTimeout(timeoutId);
  }, [isPostPayment, navigate, refreshUser]);
};
